import axios from 'axios'
import request from '@/utils/request'

// 发送短信验证码（UniApp: user/centre/app/loginCode）
export const sendSms = (phone: string) =>
  request.post('user/centre/app/loginCode', { phone })

// 手机号+验证码登录（UniApp: user/centre/app/doLogin, type=0 为验证码登录）
export const loginByPhone = (phone: string, code: string) =>
  request.post('user/centre/app/doLogin', { phone, code, type: 0 })

// 获取用户信息
export const getUserInfo = () =>
  request.post('user/centre/getUserInfoByToken', {})

// 用户首页数据
export const getUserIndex = () =>
  request.post('user/centre/json/userIndex2', {})

// 获取本人+2位好友（团购用）
export const getOwnAndTwoFriend = () =>
  request.post('user/centre/getOwnAndTwoFriend', {})

// 获取用户可用优惠券金额（UniApp: 无参数）
export const getUserCouponAmount = () =>
  request.post('user/centre/getUserUsableCouponAmount', {})

// 初始化 session（addUserFrom）
export const initSession = (from = 'web') =>
  request.post('user/centre/addUserFrom', { from })

// IP 定位
export const getLocationByIp = () =>
  request.post('search/golf/getLocation', {})

// 获取用户最大优惠金额
export const getUserMaxPrice = () =>
  request.post('user/centre/getUserMaxPrice', {})

// 获取用户已支付金额
export const getUserHasPayMoney = () =>
  request.post('user/centre/getUserHasPayMoney', {})

// 上传用户头像（用原生 axios，不经过拦截器注入公共字段，与 UniApp uni.uploadFile 一致）
export const uploadUserAvatar = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('user', 'test')
  return axios.post(`${import.meta.env.VITE_APP_BASE_URL}upload/user`, formData)
}

// 更新用户昵称和头像（简版）
export const updateUserName = (data: { name: string; headPortrait: string }) =>
  request.post('user/centre/updateName', data)

// 更新用户昵称和头像（nameHead 组件用）
export const updateNameHead = (data: { name: string; headPortrait: string }) =>
  request.post('user/centre/updateNameHead', data)

// 获取用户名片信息（编辑资料页）
export const getUserCardInfo = () =>
  request.post('user/centre/getUserCardInfo', {})

// 更新用户名片信息（按字段逐个更新）
export const updateUserCard = (data: Record<string, any>) =>
  request.post('user/centre/updateUserCard', data)

// 获取用户个人信息（含会员等级、积分、userGradeVOS）
export const getUserIndexInfo = () =>
  request.post('user/centre/json/userIndex', {})

// 获取打球统计（球场数、同组球友数、跨地区行程数）
export const getUserGolfDetailsCount = () =>
  request.post('user/centre/userGolfDetailsCount', {})
